import { LangType } from "src/i18n/LangType";
import ILanguage from "./ILanguage"

import { useTranslation } from 'react-i18next';

/**
 * @function Languages
 * @description Lista de idiomas que se van a renderizar en el combo de idiomas. Ademas realiza la traducción de los mismos.
 * @returns {ILanguage}
 */
export default function Languages (): ILanguage {
	const { t, i18n } = useTranslation();

	// Obtiene la lista de idiomas configurado en las traducciones y la renderiza.
	const listLang: { lang:string, name:string }[] = (i18n.languages as string[]).sort().map(language => {
		return {
			lang: `${language}`,
			name: `language.${language}`
		};
	}).map( al => {
		al.name = t(al.name as LangType);
		return al;
	});

	const _lang: ILanguage = {
		defaultLang: 'EN',
		list: listLang
	}

	return _lang
}
